<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="250px">

        <!-- 第三步 -->
        <div>
            <el-form-item label="作品创作性质" prop="creationNature">
            <el-select
                v-model="creationNatureText"
                placeholder="请选择作品创作性质"
                @change="selectCreationNature"
            >
                <el-option
                v-for="(item, index) in constants.creationNature"
                :key="index"
                :label="item.label"
                :value="index"
                >
                </el-option>
            </el-select>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '1'">
                <div slot="description">
                作者未参考或使用已存在作品创作的作品。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '2'">
                <div slot="description">
                作者参考已存在作品衍生创作的作品。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '3'">
                <div slot="description">
                作者参考或使用已存在的外语作品衍生创作的作品。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '4'">
                <div slot="description">
                作者参考或使用已存在作品衍生创作的系列。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '5'">
                <div slot="description">
                作者使用已存在作品衍生创作的作品。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '6'">
                <div slot="description">
                作者参考或使用已存在作品衍生创作的合集。
                </div>
            </a-alert>
            <a-alert class="tips" type="warning" v-if="form.creationNature == '7'">
                <div slot="description">
                请添加作品性质说明。
                </div>
            </a-alert>
            </el-form-item>
            <el-form-item v-if="form.creationNature == '7'" label="作品性质说明" prop="creationPropertyDesc.text">
            <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入作品性质说明"
                v-model="form.creationPropertyDesc.text"
            ></el-input>
            </el-form-item>

            <el-form-item label="作品创作类型" prop="worksType" style="margin-bottom: 50px;">
              <el-select
                  v-model="worksTypeText"
                  placeholder="请选择创作类型"
                  @change="selectWorksType"
              >
                  <el-option
                  v-for="(item, index) in constants.worksType"
                  :key="index"
                  :label="item.label"
                  :value="item"
                  >
                  </el-option>
              </el-select>
              <a-alert class="tips" type="warning" v-if="form.worksType == '1'">
                    <div slot="description" >
                      文字：小说、诗词、散文、论文等以文字形式表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '2'">
                    <div slot="description" >
                      口述：即兴的演说、授课、法庭辩论等以口头语言形式表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '3'">
                    <div slot="description" >
                      音乐：歌曲、交响乐等能够演唱或者演奏的带词或者不带词的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '4'">
                    <div slot="description" >
                      戏剧：话剧、歌剧、地方戏等供舞台演出的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '5'">
                    <div slot="description" >
                      曲艺：相声、快书、大鼓、评书等以说唱为主要形式表演的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '6'">
                    <div slot="description" >
                      舞蹈：通过连续的动作、姿势、表情等表现思想情感的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '7'">
                    <div slot="description" >
                      杂技：杂技、魔术、马戏等通过形体动作和技巧表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '8'">
                    <div slot="description" >
                      美术：绘画、书法、雕塑等以线条、色彩或者其他方式构成的有审美意义的平面或者立体的造型艺术作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '9'">
                    <div slot="description" >
                      建筑：以建筑物或者构筑物形式表现的有审美意义的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '10'">
                    <div slot="description" >
                      摄影：借助器械在感光材料或者其他介质上记录客观物体形象的艺术作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '11'">
                    <div slot="description" >
                      电影：是指摄制在一定介质上，由一系列有伴音或者无伴音的画面组成，并且借助适当装置放映或者以其他方式传播的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '12'">
                    <div slot="description" >
                      类似摄制电影方法创作的作品：是指摄制在一定介质上，由一系列有伴音或者无伴音的画面组成，并且借助适当装置放映或者以其他方式传播的作品（电视剧，动画片，视频，录音、录像制品等都归于这一类）。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '13'">
                    <div slot="description" >
                      工程设计图、产品设计图：为施工、生产绘制的工程设计图、产品设计图，以及反映地理现象、说明事物原理或者结构的地图、示意图等作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '14'">
                    <div slot="description" >
                      地图、示意图：为施工、生产绘制的工程设计图、产品设计图，以及反映地理现象、说明事物原理或者结构的地图、示意图等作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '15'">
                    <div slot="description" >
                      模型：为展示、试验或者观测等用途，根据物体的形状和结构，按照一定比例制成的立体作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '16'">
                    <div slot="description" >
                      录音制品：任何对表演的声音和其他声音的录制品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '17'">
                    <div slot="description" >
                      录像制品：电影作品和以类似摄制电影的方法创作的作品以外的任何有伴音或无伴音的连续相关形象、图像的制品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.worksType == '18'">
                    <div slot="description" >
                      其他：根据法律法规规定的其他作品。选择“其他”类时，请说明具体情况。
                    </div>
              </a-alert>
            </el-form-item>

            <el-form-item label="内容简介" prop="creationIntention.text" style="margin-bottom: 50px;">
            <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入内容简介"
                v-model="form.creationIntention.text"
            ></el-input>
            <a-alert class="tips" type="warning">
                <div slot="message">温馨提示：</div>
                <div slot="description">
                请填写中心内容及作品特点：对作品进行简述，包括主要内容、章节编排、部分划分、与同类作品相比的独特之处等。如美术作品需对作品本身的表现形式和审美特征进行描述（颜色、形态、表情等）。(注：若提交的作品样本中含有外文请在内容简介中附中文解释。)
                </div>
            </a-alert>
            </el-form-item>
            <el-form-item label="创作过程" prop="creationProcess.text">
            <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入创作过程"
                v-model="form.creationProcess.text"
            ></el-input>
            <a-alert class="tips" type="warning">
                <div slot="message">温馨提示：</div>
                <div slot="description">
                （1）创作过程：创作意图，策划和准备，创作方式（手绘、使用电脑、具体的艺术手法、软件及具体操作等），经过几次修改，每次都修改了哪些内容。 （2）使用情况：发表情况、许可他人专有使用情况。 （注：摄影作品须在创作过程中写明具体拍摄设备、光圈值、快门等详细参数。）
                </div>
            </a-alert>
            </el-form-item>
            <el-form-item label="创作完成时间" prop="finishTime">
            <el-date-picker
                v-model="form.finishTime"
                placeholder="选择日期时间"
                type="date"
                format="yyyy-MM-dd"
                value-format="timestamp"
                :picker-options="pickerOptionsStart"
                @paste.native="e => handlePaste(e, 'finishTime')"
            >
            </el-date-picker>
            </el-form-item>
            <el-form-item label="创作完成地点" prop="province">
              <china-area-data :areaData="areaData1" @change="selectArea"></china-area-data>
            </el-form-item>
            <el-form-item label="作品发表状态" prop="publishStatus">
            <el-select
                v-model="publishStatusText"
                placeholder="请选择作品发表状态"
                @change="selectPublishStatus"
            >
                <el-option
                v-for="(item, value) in constants.publishStatus"
                :key="value"
                :label="item.label"
                :value="value"
                >
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="首次发表日期" prop="publishTime" v-if="form.publishStatus == 2">
            <el-date-picker
                v-model="form.publishTime"
                placeholder="选择日期时间"
                type="date"
                format="yyyy-MM-dd"
                value-format="timestamp"
                :picker-options="pickerOptionsEnd"
                @paste.native="e => handlePaste(e, 'publishTime')"
            >
            </el-date-picker>
            </el-form-item>
            <el-form-item label="发表地点" prop="province2" v-if="form.publishStatus == 2">
            <china-area-data :areaData="areaData2" @change="selectArea2"></china-area-data>
            </el-form-item>
            <el-form-item class="submitRow">
            <el-button type="primary" @click="prev">上一步</el-button>
            <el-button type="primary" @click="next">下一步</el-button>
            </el-form-item>
        </div>
    </el-form>
  </div>
</template>

<script>
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import resultView from "../components/resultView";
import ChinaAreaData from "@/components/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../../mixins";
import constants from "@/utils/constants";


export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    multipleSelect,
    choosePersonDialog,
    resultView,
    ChinaAreaData,
  },
  props: {
    stepForm: Object,
  },
  data() {
    return {
      constants,
      step: 1,
      tabIdx: "tab1",
      creationNatureText: '',
      publishStatusText: '',
      worksTypeText:'',

      // form: {
      //   creationNature: "",
      //   creationPropertyDesc:{
      //     text:"",
      //   },
      //   finishTime: "",
      //   creationIntention:{
      //     text:"",
      //   },
      //   creationProcess:{
      //     text:"",
      //   },
      //   province: "",
      //   city: "",
      //   publishStatus: "",
      //   province2: "",
      //   city2: "",
      //   publishTime: "",

      // },
      form: this.stepForm,
      rules: {
        creationNature:[
          { required: true, message: "请选择作品创作性质", trigger: "blur" },
        ],
        worksType: [
          { required: true, message: "请选择作品创作类型", trigger: "blur" },
        ],
        finishTime: [
          { required: true, message: "请选择创作完成时间", trigger: "blur" },
          { 
            // 如果选择的是企业著作权人，则选择的完成日期，必须在企业著作权人的证件有效期的开始日期之后；
            //如果this.form.right不为[]，而且 this.form.right[0].obligeeType是为‘2’的时候，这个完成时间，必须在 this.form.right[0].startDate 这个时间之后。
            validator: (rule, value, callback) => {
              // 条件：right 非空，且 identityType 为 '2'
              if (this.form.right?.length > 0 && this.form.right[0].obligeeType === '2' && this.form.right[0].startDate ) {
                if (!value) {
                  callback(new Error("请选择创作完成时间"));
                  return;
                }
                // 获取 finishTime 的时间戳（兼容 Date 对象或时间戳）
                // console.log('完成时间：：：',value);
                const finishTimeStamp = typeof value === 'number' ? Math.floor(value / 1000) : Math.floor(new Date(value).getTime() / 1000); // 兼容 Date 对象或日期字符串
                const startTimeStamp = Number(this.form.right[0].startDate);
                // console.log(finishTimeStamp);
                // console.log(startTimeStamp);
                // 检查 finishTime 是否晚于 startDate
                if (finishTimeStamp <= startTimeStamp) {
                  callback(new Error("完成日期必须在法人组织成立日期之后"));
                } else {
                  callback(); // 验证通过
                }
              } else {
                callback(); // 不满足条件，跳过此验证
              }
            },
            trigger: "blur",
          },
        ],
        'creationIntention.text': [
          { required: true, message: "请输入内容简介", trigger: "blur" },
        ],
        'creationProcess.text': [
          { required: true, message: "请输入创作过程", trigger: "blur" },
        ],
        province: [
          { required: true, validator: this.valiCity, trigger: "blur" },
        ],
        publishStatus: [
          { required: true, message: "请选择作品发表状态", trigger: "blur" },
        ],
        publishTime: [
          { required: true, message: "请选择首次发表日期", trigger: "blur" },
        ],
        province2: [
          { required: true, validator: this.valiCity2, trigger: "blur" },
        ],

      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,

      //完成日期在发表日期之前,同时不能超过当前日期
      pickerOptionsStart: {
          disabledDate: time => {
              return time.getTime() > new Date(this.form.publishTime).getTime() || time.getTime() > Date.now()   //-8.64e7可以让开始时间和结束时间选同一天
          }
      },
      pickerOptionsEnd: {
          disabledDate: time => {
              return time.getTime() < new Date(this.form.finishTime).getTime() || time.getTime() > Date.now()     //-8.64e7可以让开始时间和结束时间选同一天
          }
      },
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  created() {
    // 从 localStorage 中加载数据
    const savedData = localStorage.getItem(`form01_${this.mid}`);
    if (savedData) {
      this.form = JSON.parse(savedData);
    }

    //this.loadData();
    // this.form = this.stepForm
    if(this.form.worksType){
      // this.worksTypeText = this.constants.worksType[this.form.worksType * 1 - 1].label;
      const found = this.constants.worksType.find(item => item.value === this.form.worksType);
      if(found){
        this.worksTypeText = found.label
      }
    }
    if(this.form.creationNature){
      this.creationNatureText = this.constants.creationNature[this.form.creationNature * 1 - 1].label;
    }else{
      this.form.creationNature = '1';
      this.creationNatureText = '原创';
    }

    if(this.form.publishStatus){
      this.publishStatusText = this.constants.publishStatus[this.form.publishStatus * 1 - 1].label;
    }else{
      this.form.publishStatus = '1';
      this.publishStatusText = '未发表';
    }


    this.areaData1 = {
      province: this.form.province,
      city: this.form.city,
    },
    this.areaData2 = {
      province: this.form.province2,
      city: this.form.city2,
    }
    // if(!this.form.province){
    //   this.form.province = '湖北省'
    // }
    // if(!this.form.city){
    //   this.form.city = '武汉市'
    // }
    // if(!this.form.province2){
    //   this.form.province2 = '湖北省'
    // }
    // if(!this.form.city2){
    //   this.form.city2 = '武汉市'
    // }
    
  },
  watch: {
    form: {
      handler(newValue) {
        // 自动保存表单数据到 localStorage
        localStorage.setItem(`form01_${this.mid}`, JSON.stringify(newValue));
      },
      deep: true
    },
    // 监听作品类型 针对美术和摄影，也就是"8"和"10"，的时候。 内容简介和创作过程，不是必填，清除验证
    'form.worksType': {
      handler(newVal) {
        console.log(newVal);
        if (newVal == 8 || newVal == 10) {
          // 清除验证规则
          // this.$refs.form.clearValidate(['creationIntention.text']);
          // this.$refs.form.clearValidate(['creationProcess.text']);
          // 或设置非必填
          this.rules['creationIntention.text'][0].required = false;
          this.rules['creationProcess.text'][0].required = false;
        } else {
          this.rules['creationIntention.text'][0].required = true;
          this.rules['creationProcess.text'][0].required = true;
        }
      },
      immediate: true
    }
  },
  methods: {
    selectWorksType(selectedItem){
      this.worksTypeText = selectedItem.label;
      this.form.worksType = selectedItem.value;
      // console.log(this.form.worksType);
    },

    async onSubmit() {
      console.log("onSubmit..");
      try {
        const formBaseResult = await this.$refs["form"].validate();
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error);
        this.mixinsScrollView();
        return;
      }
      this.setTabIdx("tab2");
    },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
    },
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      // if (!this.form.area) {
      //   callback(new Error("请选择区县"));
      //   return;
      // }
      callback();
    },
    valiCity2(rule, value, callback) {
      if (!this.form.province2) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city2) {
        callback(new Error("请选择城市"));
        return;
      }
      callback();
    },
    selectArea(data) {
      // console.log(data);
      if(data.laber == 'province'){
        this.form.province = data.value;
        this.form.city = '';
      }else if(data.laber == 'city'){
        this.form.city = data.value;
      }
      this.$refs.form.validateField('province');
      this.$refs.form.validateField('city');
      // console.log(this.form.province);
      // this.form.area = data.selectData.area.name;
    },
    selectArea2(data) {
      if(data.laber == 'province'){
        this.form.province2 = data.value;
        this.form.city2 = '';
      }else if(data.laber == 'city'){
        this.form.city2 = data.value;
      }
      this.$refs.form.validateField('province2');
      this.$refs.form.validateField('city2');
      // this.form.area2 = data.selectData.area.name;
    },

    selectCreationNature(index){
      this.creationNatureText = this.constants.creationNature[index].label;
      this.form.creationNature = this.constants.creationNature[index].value;
    },

    selectPublishStatus(index){
      this.publishStatusText = this.constants.publishStatus[index].label;
      this.form.publishStatus = this.constants.publishStatus[index].value;
      this.$refs.form.validateField('publishStatus');
      // if(index == 0 && this.form.publishTime){ // 取消发表状态，就让创作时间可以选择
      //   this.form.publishTime = ''
      // }
      // 未发表：清空发表时间、发表地点
      if (this.form.publishStatus == '1') {
        this.form.publishTime = '';
        this.form.province2 = '';
        this.form.city2 = '';
        this.areaData2 = {
          province: '',
          city: '',
        };
        // 清掉这两个字段的校验状态（因为是 v-if，字段被移除了，其实也可以不调用）
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['publishTime', 'province2']);
        });
      }
    },
    handlePaste(e, type) {
      // 1. 提取文本并清洗
      let s = ((e.clipboardData || window.clipboardData).getData('text') || '')
        .replace(/[年月－—–／．。]/g, '-')
        .replace(/日/g, '')
        .replace(/\s/g, '');

      // 2. 解析日期
      let d = new Date(s);
      if (isNaN(d.getTime())) {
        const m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
        if (!m) return;
        d = new Date(+m[1], +m[2] - 1, +m[3]);
      }
      if (isNaN(d.getTime())) return;

      e.preventDefault();
      const pasteTs = Number(d.getTime());

      // ===== 极简业务逻辑校验 =====
      // 1. 不能晚于今天
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      if (pasteTs > todayEnd.getTime()) {
        this.$message.error('日期不能晚于今天');
        return;
      }

      // 2. 相互逻辑约束
      if (type === 'finishTime' && this.form.publishTime && pasteTs > Number(this.form.publishTime)) {
        this.$message.error('创作完成时间不能晚于首次发表日期');
        return;
      }
      if (type === 'publishTime' && this.form.finishTime && pasteTs < Number(this.form.finishTime)) {
        this.$message.error('首次发表日期不能早于创作完成时间');
        return;
      }

      this.form[type] = pasteTs;
      this.$refs.form.validateField(type);
    },

    prev(){
        this.$emit('getnext',2)
    },
    async next(){
        try {
          const formBaseResult = await this.$refs["form"].validate();
        } catch (error) {
          // 有错误,定位到错误
          // eslint-disable-next-line
          console.error(error);
          this.mixinsScrollView();
          return;
        }
        this.$emit('getnext',4,this.form)
    },

  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    margin-top: 0;
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
// .tips {
//   margin-top: 20px;
// }
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
}
.signatureName {
  .el-select,
  .el-input {
    width: calc(110% / 2.4);
  }
  .el-select {
    margin-right: calc(20% / 2.4);
  }
}
.Uploader2 {
  font-size: 14px;
  height: 100%;
  text-align: center;
  background: #f9fafc;
  border-radius: 4px;
  border: 1px solid #c0ccda;
}
/deep/ .submitRow .el-form-item__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MainStepsForm .submitRow button {
  width: 46% !important;
}

.stepTitle{
  width: 100%;
  margin: 50px 0 100px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle li {
  padding: 0 10px;
}
.stepTitle li span{
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid rgba(0, 18, 22, 0.2);
  font-size: 16px;
  color: rgba(0, 18, 22, 0.2);

}
.stepTitle li p{
  color: rgba(0, 18, 22, 0.45);
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.stepTitle li.active span{
  border-color: #007DFF;
  color: #fff;
  background: #007DFF;
}
.stepTitle li.active p{
  color: #007DFF;
}

// 适配移动端
@media screen and (max-width: 991px){
  /deep/ .el-form-item__content{margin-left: 0!important;display: inline-block;width: 100%;}
  /deep/ .el-form-item__label{width: auto!important;}
  .tips{position: inherit;width: 100%;margin-top: 10px;right: 0;}
}
</style>
